<template>
    <div>
        {{d}}
    </div>
</template>
<script>
export default {
    name: "TxTree",
    props:['d']
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/TxPlugin/TxTree/TxTree.vue